export default {
  label: 'CPF',
  hint: 'Din bank skal bruge dit CPF til denne betaling. Vi videregiver det og gemmer det ikke.',
  invalid: 'Det er ikke et gyldigt CPF. Tjek de 11 cifre.',
};
